import React from 'react'
function Resume(){

    return(
        <div>
            Resume AI Coming Soon
        </div>
    )

}
export default Resume;